import { ReactComponent as Discard } from '../../../../shared/assets/images/CloseIconBlue.svg'
import { ReactComponent as Sparkles } from '../../../../shared/assets/images/Sparkles.svg'
import { Button, Input, message } from "antd";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGenerateSectionWithAI, selectSelectedKitTemplateData, setSelectedKitTemplateData, setIsEditingKit } from "../../slice/interviewSlice";
import { useParams } from "react-router-dom";
import { useGenerateNewSectionMutation } from "../../slice/interviewApiSlice";
import { apiStatuses, errorMessage } from '../../../../shared/utils/constantData';

export const GenerateNewSection = () => {
    const dispatch = useDispatch()
    const { jobId } = useParams();
    const kitTemplateData = useSelector(selectSelectedKitTemplateData)
    const [newSectionTitle, setNewSectionTitle] = useState<string>('');
    const [generateNewSectionTitle, { data, isLoading, isSuccess, isError, error }] = useGenerateNewSectionMutation();
    const updateSections = () => {
        if (kitTemplateData?.data?.sections?.evaluationMetrics && data?.data) {
            const AllSections = [
                ...kitTemplateData.data.sections.evaluationMetrics,
                data.data,
            ];

            dispatch(
                setSelectedKitTemplateData({
                    ...kitTemplateData,
                    data: {
                        ...kitTemplateData.data,
                        sections: {
                            ...kitTemplateData.data.sections,
                            evaluationMetrics: AllSections,
                        },
                    },
                })
            );
        }
    };


    useEffect(() => {

        if (isSuccess) {
            updateSections();
            dispatch(setIsEditingKit(true))
            handleSectionDiscard();
        }
        else if (isError) message.error(error?.status === apiStatuses.badRequest ? errorMessage : error?.data?.message || errorMessage, 5)
        //eslint-disable-next-line
    }, [isSuccess, isLoading, isError, error, data])
    const handleNewTitle = (value: string) => {
        setNewSectionTitle(value);
    };
    const handleSectionDiscard = () => {
        dispatch(setGenerateSectionWithAI(false))
    }
    const generateNewSection = async () => {
        const id = Number(jobId)
        const sectionTitle = newSectionTitle
        const body = { jobId: id, sectionTitle }
        await generateNewSectionTitle(body)

    }
    return (
        <div className='relative flex w-full mb-5 bg-gray-100 border rounded-lg two'>
            <div className='flex w-full'>
                <Input.TextArea
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    placeholder='Write section title'
                    style={{ border: 'none' }}
                    className="text-gray-600 borderless text-base font-normal font-['Inter'] leading-normal border-r-0 rounded-l-md overflow-hidden flex-1 !border !shadow-none !py-2 !bg-transparent hover:none resize-none w-full"
                    defaultValue={''}
                    onChange={(e) => handleNewTitle(e?.target?.value)}
                />
            </div>
            <div style={{ borderRadius: '0 0.3125rem 0.3125rem 0' }} className="inset-0 py-2 flex flex-col items-center justify-between rounded-md border-[#d8d9d9] transition-colors">
                <div className="h-[1.875rem] py-[0.4375rem] justify-center items-center gap-2 inline-flex">
                    <Button onClick={() => handleSectionDiscard()} type='text' className="flex items-center justify-between text-indigo-600 text-xs font-medium font-['Inter'] leading-none">
                        Discard
                        <Discard className='ms-2' />
                    </Button>
                </div>
                <div className="h-[1.875rem] px-2">
                    <Button
                        onClick={() => generateNewSection()}
                        type='primary'
                        className={`flex items-center ${!newSectionTitle.trim() ? 'bg-indigo-200 cursor-not-allowed' : 'bg-indigo-600'} text-white text-xs font-medium font-['Inter'] leading-none`}
                        style={{ pointerEvents: !newSectionTitle.trim() ? 'none' : 'auto' }}
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        Generate
                        <Sparkles className='ms-2' />
                    </Button>
                </div>
            </div>
        </div>
    )
}
